import React, { forwardRef, type InputHTMLAttributes } from 'react';
import classnames from 'classnames';
import IconClear from '../icons/IconClear';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  scheme?: 'dark' | 'light';
  warning?: boolean;
  onClear?: () => void;
}

const Input = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const {
    className,
    onClear,
    scheme = 'light',
    warning = false,
    ...rest
  } = props;
  const displayClear = !!onClear && !!rest.value;
  const displayCount = !!rest.maxLength;
  const inputCx = classnames(
    'w-full h-full pl-10 rounded border focus:outline-none focus:ring-2 focus:ring-blue',
    {
      'bg-white text-black': scheme === 'light',
      'bg-black border-dark text-white': scheme === 'dark',
      'ring-2 ring-red': warning,
      'pr-10': !displayClear && !displayCount,
      'pr-35': displayClear && !displayCount,
      'pr-55': !displayClear && displayCount,
      'pr-80': displayClear && displayCount,
    }
  );

  const renderCount = () => {
    const val = String(rest.value || '');
    const count = `${val.length}/${rest.maxLength}`;
    const textClass =
      val.length === rest.maxLength ? 'text-red' : 'text-black-gray';
    return <div className={`mr-10 ${textClass}`}>{count}</div>;
  };
  return (
    <div className={classnames('relative flex items-center', className)}>
      <input ref={ref} className={inputCx} {...rest} />
      <div className="absolute right-0 flex items-center">
        {displayClear && (
          <IconClear className="mr-10" scheme={scheme} onClick={onClear} />
        )}
        {displayCount && renderCount()}
      </div>
    </div>
  );
});

export default Input;
